import React from "react";
import Icon from "@mdi/react";
import {
  mdiPlusCircleOutline,
  mdiTelegram,
  mdiCloudUploadOutline,
  mdiPencil,
  mdiClose,
  mdiArrowRight,
  mdiArrowLeft,
  mdiMedium,
  mdiMinusCircleOutline,
  mdiCalendarBlank,
} from "@mdi/js";

const icons = {
  plus: mdiPlusCircleOutline,
  minus: mdiMinusCircleOutline,
  send: mdiTelegram,
  upload: mdiCloudUploadOutline,
  pencil: mdiPencil,
  close: mdiClose,
  arrowRight: mdiArrowRight,
  arrowLeft: mdiArrowLeft,
  medium: mdiMedium,
  calendar: mdiCalendarBlank,
};

export default ({
  children,
  icon,
  iconSize = "20px",
  onClick,
  arrowRight,
  arrowLeft,
  ...modifiers
}) => {
  let className = "button";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <button className={className} onClick={onClick}>
      {icon && (
        <Icon
          path={icons[icon]}
          size={iconSize}
          color="white"
          className="button_icon"
        />
      )}
      {arrowLeft && <div className="button_arrowLeft">{"<- "}</div>}
      <div className="button_label">{children}</div>
      {arrowRight && <div className="button_arrowRight">{" ->"}</div>}
      {modifiers.loading && <span className="button_spinner"></span>}
    </button>
  );
};
